import React from 'react';

const terms = [
  {
    title: "1. Introduction",
    body: `Welcome to Fit-Mate24! Fit Mate24 is a fitness app based in Germany. By accessing or using our app, you agree to these Terms and Conditions. If you do not agree, please do not use the app. Fit Mate24 is registered in Germany. Our contact email is info@fit-mate24.com.`,
  },
  {
    title: "2. Eligibility",
    body: `To use Fit-Mate24, you must: Be at least 18 years old. Have the legal capacity to enter into these Terms. Comply with all applicable local, national, and/or international laws. This app is intended for personal use only. Fit Mate24 reserves the right to deny or revoke access if these criteria are not met.`,
  },
  {
    title: "3. Subscription and Fees",
    body: `Fit Mate24 may require a subscription fee for its premium features. Fees are displayed before purchase and are subject to change. Subscriptions automatically renew unless canceled before the end of the current period. All charges are non-refundable, unless otherwise stated. You can cancel your subscription at any time via the app settings or your app store platform.`,
  },
  {
    title: "4. User Conduct",
    body: `Fit Mate24 is designed to foster positive interactions among users. Users may not: Harass, abuse, or harm others; Post any unlawful, offensive, or inappropriate content; Use the service for illegal purposes or in violation of any applicable laws. Violations may result in suspension or termination of user accounts.`,
  },
  {
    title: "5. Privacy and Data Protection",
    body: `We value your privacy and handle your personal data in accordance with applicable data protection laws. Please read our Privacy Policy (https://fit-mate24.com/privacy) for more information. By using Fit Mate24, you acknowledge and agree that your information is collected, used, and disclosed as described in the Privacy Policy.`,
  },
  {
    title: "6. Intellectual Property",
    body: `All content, trademarks, and materials provided through Fit Mate24 are the property of Fit Mate24 or its licensors. You may not copy, distribute, or create derivative works except as expressly permitted.`,
  },
  {
    title: "7. Liability",
    body: `We strive to provide a safe and reliable platform. Fit Mate24 is not liable for: Any indirect, incidental, or consequential damages; Any loss resulting from the use of our app or services. The company’s aggregate total liability is limited to the total subscription fees paid by the user.`,
  },
  {
    title: "8. Account Termination",
    body: `You may terminate your account at any time under your account settings. Fit Mate24 reserves the right to terminate or suspend accounts at its discretion.`,
  },
  {
    title: "9. Governing Law and Jurisdiction",
    body: `These Terms are governed by the laws of Germany. Any disputes arising from these Terms shall be subject exclusively to the jurisdiction of courts in Germany.`,
  },
  {
    title: "10. Amendments",
    body: `Fit Mate24 may update these Terms from time to time. Material changes will be communicated via the app or website.`,
  },
  {
    title: "11. Contact Information",
    body: `For questions or concerns about these Terms, please contact us at info@fit-mate24.com.`,
  },
];

const pageStyle = {
  minHeight: '100vh',
  // width: '100vw',
  margin: 0,
  overflowX: 'hidden', // prevent horizontal scroll on body
  display: 'flex',
  justifyContent: 'center',
  boxSizing: 'border-box',
};

const cardStyle = {
  background: '#18181a',
  color: 'white',
  boxShadow: '0 5px 24px #000a',
  fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", Arial, sans-serif',
  padding: 24,
  // maxWidth: 600,       // limit max width to avoid overflow
  width: '100%',       // responsive width
  overflowWrap: 'break-word', // break long words/links
  wordWrap: 'break-word',     // fallback
  boxSizing: 'border-box',
};

const headerStyle = {
  fontSize: 28,
  fontWeight: 600,
  fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", Arial, sans-serif',
  marginBottom: 14,
  textAlign: 'center',
};

const dateStyle = {
  fontSize: 12,
  marginBottom: 20,
  color: '#bbb',
  textAlign: 'center',
};

export default function TermsAndConditions() {
  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <div style={headerStyle}>Terms and Conditions<br />for Fit-Mate24</div>
        <div style={dateStyle}>Last updated: 01 January 2023</div>
        {terms.map((section, idx) => (
          <div key={idx} style={{ marginBottom: 20 }}>
            <strong>{section.title}</strong>
            <div style={{ fontSize: 15, marginTop: 4, whiteSpace: 'pre-line' }}>
              {section.body}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
